/*
 *
 * UserCookieConsent constants
 *
 */

export const GET_COOKIE_CONSENT_REQUEST_SENT =
  "src/PatientRegister/GET_COOKIE_CONSENT_REQUEST_SENT";
export const GET_COOKIE_CONSENT_REQUEST_SUCCEED =
  "src/PatientRegister/GET_COOKIE_CONSENT_REQUEST_SUCCEED";
export const GET_COOKIE_CONSENT_REQUEST_FAILED =
  "src/PatientRegister/GET_COOKIE_CONSENT_REQUEST_FAILED";

export const POST_COOKIE_CONSENT_PROVIDED_SENT =
  "src/PatientRegister/POST_COOKIE_CONSENT_PROVIDED_SENT";
export const POST_COOKIE_CONSENT_PROVIDED_SUCCEED =
  "src/PatientRegister/POST_COOKIE_CONSENT_PROVIDED_SUCCEED";
export const POST_COOKIE_CONSENT_PROVIDED_FAILED =
  "src/PatientRegister/POST_COOKIE_CONSENT_PROVIDED_FAILED";
